import type { ReactElement } from "react"
import { useMemo } from "react"

import { FilterChip } from "@/components/common/Filters"
import type { Option } from "@/types/form-fields"

interface InventoryFilterChipGroupProps<T extends string> {
  label: string
  values: T[]
  options: Option<T>[]
  onRemove: (value: T) => void
  testId: string
}

export const InventoryFilterChipGroup = <T extends string>({
  label,
  values,
  options,
  onRemove,
  testId,
}: InventoryFilterChipGroupProps<T>): ReactElement => {
  const labelsMap = useMemo(() => new Map(options.map((option) => [option.value, option.label])), [options])

  return (
    <>
      {values.map((value) => {
        const optionLabel = labelsMap.get(value)
        if (!optionLabel) return null

        return (
          <FilterChip
            key={value}
            label={`${label}: ${optionLabel}`}
            onDelete={() => onRemove(value)}
            testId={`${testId}-${value}`}
          />
        )
      })}
    </>
  )
}
